import React, { Component } from "react";
import { Link } from "react-router-dom";
import withStyles from "@material-ui/core/styles/withStyles";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
// redux stuff
import { connect } from "react-redux";
import { loginUser } from "../redux/actions/userActions";

//MUI stuff
import Grid from "@material-ui/core/Grid";
const styles = {
  form: {
    textAlign: "center",
  },
  image: {
    margin: "20px auto 20px auto",
  },
  pageTitle: {
    margin: "20px auto 20px auto",
  },
  textField: {
    margin: "10px auto 10px auto",
  },
  button: {
    marginTop: "20px",
    marginBottom: "20px",
    position: "relative",
  },
  customError: {
    color: "red",
    fontsize: "10px",
  },
  progress: {
    position: "absolute",
  },
};

class login extends Component {
  constructor() {
    super();
    this.state = {
      email: "",
      password: "",
      errors: {},
    };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.UI.errors) {
      this.setState({ errors: nextProps.UI.errors });
    }
  }
  handleSubmit = (event) => {
    event.preventDefault();
    const userData = {
      email: this.state.email,
      password: this.state.password,
    };
    this.props.loginUser(userData, this.props.history);
  };
  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };
  render() {
    const {
      classes,
      UI: { loading },
    } = this.props;
    const { errors } = this.state;

    return (
      <Grid container className={classes.form}>
        <Grid item sm />
        <Grid item sm>
          {/* <img src={AppIcon} alt="monkey" className={classes.image} /> */}
          <Typography variant="h2" className={classes.pageTitle}>
            Login
          </Typography>
          <form noValidate onSubmit={this.handleSubmit}>
            <TextField
              id="email"
              name="email"
              type="email"
              label="Email"
              className={classes.textField}
              helperText={errors.email}
              error={errors.email ? true : false}
              value={this.state.email}
              onChange={this.handleChange}
              fullWidth
            />
            <TextField
              id="password"
              name="password"
              type="password"
              label="Password"
              className={classes.textField}
              helperText={errors.password}
              error={errors.password ? true : false}
              value={this.state.password}
              onChange={this.handleChange}
              fullWidth
            />
            {errors.general && (
              <Typography variant="body2" className={classes.customError}>
                {errors.general}
              </Typography>
            )}
            <Button
              type="submit"
              variant="contained"
              color="primary"
              className={classes.button}
              disabled={loading}
            >
              Login
              {loading && (
                <CircularProgress size={30} className={classes.progress} />
              )}
            </Button>
            <br />
            <small>
              dont have an account ? sign up <Link to="/signup">here</Link>
            </small>
          </form>
        </Grid>
        <Grid item sm />
      </Grid>
    );
  }
}

login.propTypes = {
  classes: PropTypes.object.isRequired,
  loginUser: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  UI: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
  UI: state.UI,
});

const mapActionsToProps = {
  loginUser,
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(withStyles(styles)(login));

// class login extends Component {
//   constructor() {
//     super();
//     this.state = {
//       email: "",
//       password: "",
//       errors: {},
//     };
//   }

//   handlesubmit = (event) => {
//     event.preventDefault();
//     const userData = {
//       email: this.state.email,
//       password: this.state.password,
//     }.this.props.loginUser(userData, this.props.history);
//   };

//   handleChange = (event) => {
//     this.setState({
//       [event.target.name]: event.target.value,
//     });
//   };
//   render() {
//     const { classes } = this.props;
//     const {
//       errors,
//       UI: { loading },
//     } = this.state;
//     return (
//       <Grid container justify="center" className={classes.form}>
//         <Grid item xs={10} sm></Grid>
//         <Grid item xs={10} sm>
//           <h2>ICON</h2>
//           {/* <img src={} alt="icon" className={classes.image} /> */}
//           <Typography variant="h2" className={classes.pageTitle}>
//             Login{" "}
//           </Typography>
//           <form noValidate onSubmit={this.handlesubmit}>
//             <TextField
//               id="email"
//               name="email"
//               type="email"
//               label="Email"
//               className={classes.textField}
//               helperText={errors.email}
//               error={errors.email ? true : false}
//               value={this.state.email}
//               onChange={this.handleChange}
//               fullWidth
//             ></TextField>
//             <TextField
//               id="password"
//               name="password"
//               type="password"
//               label="Password"
//               className={classes.textField}
//               helperText={errors.password}
//               error={errors.password ? true : false}
//               value={this.state.password}
//               onChange={this.handleChange}
//               fullWidth
//             ></TextField>
//             {errors.general && (
//               <Typography varient="body2" className={classes.customError}>
//                 {errors.general}
//               </Typography>
//             )}
//             <Button
//               type="submit"
//               variant="contained"
//               color="secondary"
//               className={classes.button}
//               disabled={loading}
//             >
//               Login{" "}
//               {loading && (
//                 <CircularProgress
//                   size={30}
//                   className="classes.progress"
//                 ></CircularProgress>
//               )}
//             </Button>
//             <br />
//             <small>
//               dont have an account ? sign up <Link to="/signup">here</Link>
//             </small>
//           </form>
//         </Grid>
//         <Grid item sm></Grid>
//       </Grid>
//     );
//   }
// }

// login.propTypes = {
//   classes: PropTypes.object.isRequired,
//   loginUser: PropTypes.func.isRequired,
//   user: PropTypes.object.isRequired,
//   UI: PropTypes.object.isRequired,
// };

// const mapStateToProps = (state) => ({
//   user: state.user,
//   UI: state.UI,
// });

// const mapActionsToProps = {
//   loginUser,
// };
// export default connect(
//   mapStateToProps,
//   mapActionsToProps
// )(withStyles(styles)(login));
